// execCommand fallback for browsers that refuse the Clipboard API; its result is the only proof of a copy
function copyWithSelection(text: string): boolean {
  const activeElement = document.activeElement instanceof HTMLElement ? document.activeElement : null
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  let hasCopied: boolean
  try {
    hasCopied = document.execCommand('copy')
  } catch {
    hasCopied = false
  }
  textarea.remove()
  activeElement?.focus({preventScroll: true})
  return hasCopied
}

// Resolves to whether the text really reached the clipboard; never rejects
export async function writeToClipboard(text: string): Promise<boolean> {
  if(navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // permission refused, document not focused or no secure context: try the selection copy
    }
  }
  return copyWithSelection(text)
}
